<template>
  <div class="c-o-search-header">
    <div class="c-o-search-header__inner">
      <div class="c-o-search-header__block">
        <h1 class="c-o-search-header__title">{{ titleText }}</h1>
        <p class="c-o-search-header__body" v-html="information"></p>
      </div>
      <div class="c-o-search-header__block">
        <div class="c-o-search-header__search">
          <reactive-request-form-selector :selected-region="getRegion" :selected-category="getCategory" />
        </div>
      </div>
    </div>
    <div class="c-o-search-header__meta">
      <p v-if="showCount">Antal resultat: {{nrOfCompanies}} st</p>
      <p v-else></p>
      <button-atom
        :icon="'reset'"
        :label="'Återställ alla val'"
        :modifiers="'c-a-button--small c-a-button--theme-gray'"
        @buttonClicked="reset"
      ></button-atom>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  FETCH_COMPANIES,
  GET_COMPANIES,
  SET_QUERY_ACTION,
  GET_PAGE,
  IS_LOADING,
  GET_ERROR,
  RESET_SEARCH_ACTION,
  GET_SEARCH_PARAMS,
  GET_FACET_TITLE,
  GET_FACET_CONTENT,
  GET_CATEGORY,
  GET_REGION
} from "../../../../store/store-models/companies-model";

import AtomInputSearch from "../../atoms/form/AtomInputSearch.vue";
import ButtonAtom from "../../atoms/AtomButton.vue";
import Icon from "../../atoms/AtomIcon.vue";
import ReactiveRequestFormSelector from "../../molecules/MoleculeReactiveRequestFormSelector.vue";

export default {
  components: {
    AtomInputSearch,
    ButtonAtom,
    Icon,
    ReactiveRequestFormSelector
  },
  props:[
    'title'
  ],
  data() {
    return {
      hasSearched: false,


    };
  },
  computed: {
    ...mapGetters({
      companies: GET_COMPANIES,
      currentPage: GET_PAGE,
      isLoading: IS_LOADING,
      error: GET_ERROR,
      searchParams: GET_SEARCH_PARAMS,
      getRegion: GET_REGION,
      getCategory: GET_CATEGORY,
      getSeachTitle: GET_FACET_TITLE,
      getSeachContent: GET_FACET_CONTENT
    }),
    nrOfCompanies: function() {
      return !this.isLoading ? this.companies.meta.count : 0;
    },
    titleText: {
      get(){
        return this.title || "Sök hantverkare";
      }
    },
    information: {
      get(){
        return this.getSeachContent || "BraByggare är en kostnadsfri tjänst där du tryggt och enkelt får tag på  kvalitetssäkrade hantverkare för ditt projekt. Skapa en förfrågan, beskriv vad du behöver hjälp med – så får du snabbt svar.";
      }
    },
    queryString: {
      get() {
        return this.searchParams.q;
      },
      set(val) {
        this.setQuery(val);
      }
    },
    showCount: {
      get() {
        return (
          (this.hasSearched && this.searchParams.q.length) ||
          this.searchParams.category ||
          this.searchParams.region ||
          this.searchParams.rating ||
          this.searchParams.certid
        );
      }
    }
  },
  methods: {
    ...mapActions({
      fetchCompanies: FETCH_COMPANIES,
      setQuery: SET_QUERY_ACTION,
      resetSearch: RESET_SEARCH_ACTION
    }),
    searchFunc() {
      this.fetchCompanies();
      this.hasSearched = true;
    },
    reset() {
      this.resetSearch();
      this.fetchCompanies();
      this.hasSearched = false;
      this.$emit("reset");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/search/OrganismSearchHeaderCompanies.vue